// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__11JKh","large":"styles_large__DPnN5"};